export const SESSION_STORAGE_KEY = 'token';

export const useGetToken = () =>
  JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY));
export const useSetToken = (token) =>
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(token));
